import { makeStyles } from '@material-ui/core';

import { COLOR_DARK_GRAY, COLORS, DOCUMENT_SCORE_PANEL_WIDTH } from 'src/data/ui';
import { NAVIGATION_BAR_HEIGHT } from 'src/data/common';

export const useStyles = (props) => {
  const focusedVariationStyles = {
    '& span': {
      backgroundColor: COLORS.primary.light,
    },
  };
  const selectedVariationColorStyles = {
    backgroundColor: `${COLOR_DARK_GRAY} !important`,
    color: `${COLORS.neutral.white} !important`,
  };

  const styles = (theme) => ({
    root: {
      position: 'relative',
      maxWidth: 768,
    },
    editable: {
      paddingRight: DOCUMENT_SCORE_PANEL_WIDTH,

      '& [data-variation]': {
        '&:hover span': {
          backgroundColor: COLORS.primary.light,
        },
      },
      '& span ::selection': selectedVariationColorStyles,
      [`& [data-instance-id="${props.activeVariationInstanceId}"]`]: focusedVariationStyles,
    },
    documentScores: {
      position: 'absolute',
      top: 0, // should be positioned on the same vertical level as "editable"
      bottom: 0,
      right: -150,
      width: DOCUMENT_SCORE_PANEL_WIDTH,
    },
    portalDetailsPanel: {
      position: 'fixed',
      top: NAVIGATION_BAR_HEIGHT,
      right: 0,
      overflowY: 'auto',
      height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)`,
      zIndex: theme.zIndex.modal,
      boxShadow: '-10px 9px 13px rgba(115, 136, 189, 0.1)',
    },
  });

  return makeStyles(styles, { name: 'ViewCanvasWhiteboard' })(props);
};
